import { AppPageHeader } from '@/components/_common';
import { ListCompaniesQuery } from '@/core/domain/enterprise/Companies/Companies.types';
import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';
import { Button } from 'antd';

import { useIntl } from 'react-intl';
import CompaniesExtraFilters from '../CompaniesExtraFilters';

const CompaniesFilters: React.FC<ExtraFiltersProps<ListCompaniesQuery>> = ({
  queryParams,
  setQueryParams,
}) => {
  const intl = useIntl();

  return (
    <AppPageHeader
      onSearch={(value) =>
        setQueryParams((prev) => ({ ...prev, search: value }))
      }
      searchValue={queryParams?.search}
      extraFilters={
        <CompaniesExtraFilters
          queryParams={queryParams}
          setQueryParams={setQueryParams}
        />
      }
      headerActions={({
        isShowingFilters,
      }: {
        // eslint-disable-next-line react/no-unused-prop-types
        isShowingFilters: boolean;
      }) =>
        isShowingFilters && (
          <Button
            type="primary"
            onClick={() => setQueryParams({ active: true, order: 'ASC' })}
          >
            {intl.formatMessage({ id: 'commons.clear.filters' })}
          </Button>
        )
      }
    />
  );
};

export default CompaniesFilters;
